import React from 'react';

import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
//
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"

import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import Button from '@atoms/Button';


export default function FormSuccess(props) {

  const data = useStaticQuery(graphql`
    query {
        file(relativePath: { eq: "form-sucsess.png" }) {
        childImageSharp{
            fluid(maxWidth: 800) {
                ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
        }
        }
    }
  `);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));



  return (
    <Box>
      <Dialog
        open={props.isOpen}
        onClose={props.handleClose}
        fullScreen={fullScreen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >

      <Box style={{padding: "10%"}}>

        <DialogTitle 
          id="alert-dialog-title"
         >

           {" قد تم التواصل معاك وسوف نتواصل معاك قريبا"}

         </DialogTitle>
        
        
        
        <DialogContent>
           <Img 
              fluid={data.file.childImageSharp.fluid}
              alt="دورلى"
           />
        </DialogContent>


        <DialogActions style={{justifyContent: 'center'}}>
          <Button onClick={props.handleClose} style={{width: '80%'}} color="secondary"  variant="contained">
            شكرا جزيلا 
          </Button>
        </DialogActions>

       </Box>

      </Dialog>
    </Box>
  );
}

